import { Camera, Mic, Loader2, Car } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Field } from "./Field";

// Modal "Recibir vehículo": captura manual + asistentes IA (Foto/Voz). Presentacional puro.
export const RecibirVehiculoModal = ({
  formOpen, cerrarRecepcion, setFormOpen, fotoIaActiva, vozIaActiva, fileInputRef,
  aiLoading, dictar, escuchando, onFotoSeleccionada, form, setForm, recibir, saving,
}) => (
  <Dialog open={formOpen} onOpenChange={(o) => { if (!o) cerrarRecepcion(); else setFormOpen(true); }}>
    <DialogContent className="rounded-none border-[#0A0A0A] bg-[#0A0A0A] text-white max-w-lg max-h-[90dvh] overflow-y-auto overflow-x-hidden">
      <DialogHeader>
        <DialogTitle className="font-display font-black text-white">Recibir vehículo</DialogTitle>
        <DialogDescription className="text-white/50">Registra los datos del auto en resguardo.</DialogDescription>
      </DialogHeader>
      {/* Sprint 11.0 — Captura híbrida IA (visible según configuración de la sucursal) */}
      {(fotoIaActiva || vozIaActiva) && (
        <div className={`grid gap-2 pt-1 ${fotoIaActiva && vozIaActiva ? "grid-cols-2" : "grid-cols-1"}`}>
          {fotoIaActiva && (
            <button type="button" onClick={() => fileInputRef.current?.click()} disabled={aiLoading} data-testid="valet-ai-escanear"
              className="h-11 border border-[#FFCC00]/50 text-[#FFCC00] text-xs font-bold uppercase tracking-wider flex items-center justify-center gap-2 hover:bg-[#FFCC00]/10 disabled:opacity-50">
              <Camera className="h-4 w-4" /> Escanear <span className="text-white/50 normal-case">(12 folios)</span>
            </button>
          )}
          {vozIaActiva && (
            <button type="button" onClick={dictar} disabled={aiLoading} data-testid="valet-ai-dictar"
              className={`h-11 border text-xs font-bold uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-50 ${escuchando ? "bg-[#EF4444] text-white border-[#EF4444] animate-pulse" : "border-[#FFCC00]/50 text-[#FFCC00] hover:bg-[#FFCC00]/10"}`}>
              <Mic className="h-4 w-4" /> {escuchando ? "Escuchando…" : "Dictar"} <span className="text-white/50 normal-case">(3 folios)</span>
            </button>
          )}
        </div>
      )}
      <input ref={fileInputRef} type="file" accept="image/*" capture="environment" onChange={onFotoSeleccionada} className="hidden" data-testid="valet-ai-file" />
      {escuchando && (
        <div className="flex items-center gap-2 text-[#EF4444] text-xs font-bold uppercase tracking-wider py-1" data-testid="valet-escuchando">
          <span className="h-2 w-2 rounded-full bg-[#EF4444] animate-pulse" /> Escuchando…
        </div>
      )}
      {aiLoading && (
        <div className="flex items-center gap-2 text-[#FFCC00] text-xs font-bold uppercase tracking-wider py-1" data-testid="valet-ai-loading">
          <Loader2 className="h-4 w-4 animate-spin" /> Analizando con IA…
        </div>
      )}
      <div className="grid grid-cols-2 gap-3 pt-2">
        <Field label="Nombre" testid="valet-form-nombre" value={form.nombre_cliente} onChange={(v) => setForm({ ...form, nombre_cliente: v })} />
        <Field label="Marca / Modelo" testid="valet-form-marca" value={form.marca_modelo} onChange={(v) => setForm({ ...form, marca_modelo: v })} />
        <Field label="Color" testid="valet-form-color" value={form.color} onChange={(v) => setForm({ ...form, color: v })} />
        <Field label="Placas" testid="valet-form-placa" value={form.placa} onChange={(v) => setForm({ ...form, placa: v.toUpperCase() })} />
        <div className="col-span-2">
          <Field label="Objetos de valor" testid="valet-form-objetos" value={form.objetos_valor} onChange={(v) => setForm({ ...form, objetos_valor: v })} />
        </div>
      </div>
      <button onClick={recibir} disabled={saving} data-testid="valet-form-save"
        className="btn-hard w-full h-12 mt-4 bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] font-bold uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-60">
        {saving ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Car className="h-5 w-5" /> Registrar</>}
      </button>
    </DialogContent>
  </Dialog>
);

export default RecibirVehiculoModal;
